import { App_Url_New } from "@/src_new/shared/common/static";

import type { ResumeTarget } from "../utils/resumeJourney";

const travelGetQuoteStep = (stepIndex: number) =>
  `${App_Url_New.frontLinks.insurance.travelGetQuote}?step=${stepIndex}`;

export const TRAVEL_RESUME_STEP_TARGETS = {
  step_1_pre_request: {
    path: travelGetQuoteStep(1),
    stepIndex: 1,
    stepLabel: "Personal Details",
  },
  step_2_pre_request: {
    path: travelGetQuoteStep(2),
    stepIndex: 2,
    stepLabel: "Travel Details",
  },
  quote_request: {
    path: travelGetQuoteStep(3),
    stepIndex: 3,
    stepLabel: "Get Quote",
  },
  selected_quote: {
    path: travelGetQuoteStep(3),
    stepIndex: 3,
    stepLabel: "Buy Now",
  },
  step_5_post_request: {
    path: travelGetQuoteStep(4),
    stepIndex: 4,
    stepLabel: "Document Upload",
  },
  step_6_post_request: {
    path: travelGetQuoteStep(5),
    stepIndex: 5,
    stepLabel: "Additional Details",
  },
  step_7_post_request: {
    path: travelGetQuoteStep(6),
    stepIndex: 6,
    stepLabel: "Payment",
  },
  step_8_post_request: {
    path: App_Url_New.frontLinks.insurance.travelPolicyResult,
    stepLabel: "Policy Issue",
  },
} satisfies Record<string, ResumeTarget>;

export const TRAVEL_RESUME_STEP_FALLBACK_ORDER = [
  "step_8_post_request",
  "step_7_post_request",
  "step_6_post_request",
  "step_5_post_request",
  "selected_quote",
  "quote_request",
  "step_2_pre_request",
  "step_1_pre_request",
] as const;

export type TravelResumeStepName = keyof typeof TRAVEL_RESUME_STEP_TARGETS;
